import { DEFAULT_BORDER, DEFAULT_TRANSITION } from 'constants/global';

export const inputsWrapperStyle = (type, error) => ({
  w: 'full',
  h: 'unset',
  flex: '1 1 auto',
  border: DEFAULT_BORDER,
  borderColor: error ? '#E5715E' : 'ourGrayFour',
  borderRadius: type === 'textarea' ? { laptop: '32px', mobile: '24px' } : '40px',
  alignItems: type === 'textarea' ? 'start' : 'center',
  transition: DEFAULT_TRANSITION,
  cursor: 'pointer',
  _hover: { borderColor: 'deepBlue' },
  _active: { borderColor: 'ourGreen' },
  _focusWithin: type !== 'select' && { borderColor: 'ourGreen' },
  bgColor: 'ourWhite',
  p: { mobile: '18px 18px 18px 20px', tablet: '18px 24px' },
});

export const phoneInputWrapperStyle = error => ({
  w: 'full',
  h: 'unset',
  flex: '1 1 auto',
  position: 'relative',
  zIndex: 25,
  border: DEFAULT_BORDER,
  borderColor: error ? '#E5715E' : 'ourGrayFour',
  borderRadius: '40px',
  alignItems: 'center',
  transition: DEFAULT_TRANSITION,
  cursor: 'pointer',
  _hover: { borderColor: 'deepBlue' },
  _active: { borderColor: 'ourGreen' },
  _focusWithin: { borderColor: 'ourGreen' },
  bgColor: 'ourWhite',
  pr: { mobile: '20px', tablet: '24px' },
});
